// extracted by mini-css-extract-plugin
module.exports = {"heading":"Press-module--heading--3fgph","entries":"Press-module--entries--3h4gO","ctaDesktop":"Press-module--ctaDesktop--243vm","ctaMobile":"Press-module--ctaMobile--1pst8"};